import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";

const icon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34], shadowSize: [41, 41],
});

export default function BranchMap({ branches = [], height = 420, center, zoom = 9 }) {
  const c = center || (branches.length ? [branches[0].lat, branches[0].lng] : [51.35, 6.95]);
  return (
    <MapContainer center={c} zoom={zoom} style={{ height, width: "100%" }} scrollWheelZoom={false} data-testid="branch-map">
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; OpenStreetMap' />
      {branches.map((b) => (
        <Marker key={b.id} position={[b.lat, b.lng]} icon={icon}>
          <Popup>
            <div style={{ minWidth: 160 }}>
              <strong>{b.name}</strong><br />
              <span style={{ fontSize: 12, color: "#4B5563" }}>{b.hospital_name}<br />{b.address?.street}, {b.address?.zip} {b.address?.city}</span><br />
              <Link to={`/standorte/${b.slug}`} style={{ color: "#E0243A", fontWeight: 600 }}>Details ansehen →</Link>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
